import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "personal-data" }
const _hoisted_2 = { class: "card-header-title" }
const _hoisted_3 = { class: "col py-4 px-0" }
const _hoisted_4 = { class: "fs-5" }
const _hoisted_5 = { class: "col p-4 px-0" }
const _hoisted_6 = { class: "d-flex pt-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Logout ")
const _hoisted_8 = { class: "ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitForm = _resolveComponent("MrUiKitForm")!
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MrUiKitCard, {
      headerClasses: ['border-bottom'],
      bodyClasses: ['pt-0']
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.t('account.personalData.title')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t('account.personalData.subtitle')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MrUiKitForm, {
            modelValue: _ctx.userPasswordForm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userPasswordForm) = $event)),
            fields: _ctx.formFields,
            onSubmit: _ctx.onClick
          }, {
            default: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createVNode(_component_MrUiKitButton, {
                    type: "button",
                    classes: ['btn-warning'],
                    onClick: _ctx.onLogout
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_MrUiKitButton, {
                    type: "submit",
                    disabled: slotProps.disabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('common.resetPasswordButton')), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "fields", "onSubmit"])
        ])
      ]),
      _: 1
    })
  ]))
}